import {queryServer} from './api';
import { addGroup } from '../redux/groupSlice';
import { addHeart, addGroupHeart } from '../redux/heartSlice';
import { updateUser } from '../redux/userSlice';

export const fetchAndDispatchGroups = async (userGroupIDs, dispatch, groups) => {
    let localUpdatedGroups = [];
    await Promise.all(userGroupIDs.map(async (groupID) => {
      const group = await queryServer(groupID, 'groups');
      console.log("Group from server: ", group);

      // add to local store only if not already there
      if(!groups.find((g) => g.id === group.id)) {
        dispatch(addGroup(group));
        localUpdatedGroups.push(group);
      }
    }));

    return localUpdatedGroups;
    // .then(fetchAndDispatchGroupHearts()) does not use latest groups state, flag needed to give buffer for store to update
    // setGroupFetchComplete(true);
}

export const fetchAndDispatchHearts = async (userHeartIDs, dispatch, hearts) => {
    // look up each heart ID in the database, then add the heart to local store
    let localUpdatedHearts = [];
    await Promise.all(userHeartIDs.map(async (heartID) => {
      const heart = await queryServer(heartID, 'hearts');
      console.log("Heart from server: ", heart);

      // add to local store only if not already there
      if(!hearts.find((h) => h.id === heart.id)) {
        dispatch(addHeart(heart));
        localUpdatedHearts.push(heart);
      }
    }));
    return localUpdatedHearts;
} 

// look up each group's (non-user-owned) hearts in the database, then add the heart to local store
// Issue: we don't have the list of hearts for each group until we fetch the group from the server
export const fetchAndDispatchGroupHearts = async (updatedGroups, dispatch, hearts, groupHearts) => {
    console.log("Groups inside groupHearts func: ", updatedGroups);
    updatedGroups.map(async (group) => {
      await Promise.all(group.hearts.map(async (heartID) => {
        const heart = await queryServer(heartID, 'hearts');
        
        // add to local store only if not already there (and not in user's hearts)
        if(!groupHearts.find((h) => h.id === heart.id) && !hearts.find((h) => h.id === heart.id)){
          console.log("Group heart from server: ", heart);
          dispatch(addGroupHeart(heart));
        }
        else {
          console.log("Group heart already in heart store, not adding to groupHearts: ", heart);
        }
      }));
    });
}

export const initializeUserAndData = async (userID, dispatch, groups, hearts, setLoading, setGroupFetchComplete) => {
    try {
        const userDataResponse = await queryServer(userID, 'users');
        console.log("User data from server: ", userDataResponse);
        dispatch(updateUser(userDataResponse));
        dispatch(setLoading(true));

        // add a 2s timeout for testing
        setTimeout(async () => {
            await fetchAndDispatchGroups(userDataResponse.groups, dispatch, groups);
            await fetchAndDispatchHearts(userDataResponse.hearts, dispatch, hearts);
            setGroupFetchComplete(true);
            dispatch(setLoading(false));
        }, 2000);

    } catch (error) {
        console.error("Error fetching user: ", error);
        setLoading(false);
    }
};

// Fetch user data from DynamoDB and update Redux store - errors not caught here
export const fetchUserData = async (userEmail, dispatch, groups, hearts, setLoading, setUserLoaded, groupHearts) => {
      try {
        const dynamoUser = await queryServer(userEmail, 'users');
        if (!dynamoUser) {
          throw new Error("User not found in DynamoDB.");
        }
        console.log("User data from server: ", dynamoUser);
        dispatch(updateUser(dynamoUser)); // Store the user information in Redux
  
        // Fetch the user's groups and hearts
        const updatedGroups = await fetchAndDispatchGroups(dynamoUser.groups, dispatch, groups);
        const updatedHearts = await fetchAndDispatchHearts(dynamoUser.hearts, dispatch, hearts);
  
        // Fetch and dispatch group hearts
        await fetchAndDispatchGroupHearts(updatedGroups, dispatch, updatedHearts, groupHearts)
  
        console.log("Setting user loaded to true");
        dispatch(setUserLoaded(true));
        dispatch(setLoading(false));
      } catch (error) {
        console.error("Error fetching user data", error);
        throw error;
      }
};